import getMuiTheme from 'material-ui/styles/getMuiTheme';

// Design system tokens — see docs/design-system.md (canonical source).
// Components must use these constants (or the CSS variables from
// design-system.css) instead of hardcoded hex values.
export const DS = {
    bg: '#f5f6f8',
    surface: '#ffffff',
    ink: '#1c1e21',
    textSecondary: '#555555',
    textMuted: '#777777',
    border: '#e2e5e9',
    borderStrong: '#cfd4da',
    borderFaint: '#eceff2',
    primary: '#1a5fb4',
    primaryHover: '#174f96',
    primaryDark: '#123c72',
    primaryDeep: '#0d2b52',
    primaryTint: '#e8f0fb',
    primaryDisabled: '#9db6d4',
    success: '#1a7f37',
    error: '#b00020',
    warning: '#9a6700',
    radiusCard: 8,
    radiusControl: 6,
    shadowOverlay: '0 12px 32px rgba(28, 30, 33, 0.18)',
    font: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, Roboto, "Helvetica Neue", Arial, sans-serif'
};

const themeDefault = getMuiTheme({
    fontFamily: DS.font,
    borderRadius: DS.radiusControl,
    palette: {
        primary1Color: DS.primary,
        primary2Color: DS.primaryDark,
        primary3Color: DS.primaryDisabled,
        accent1Color: DS.primary,
        accent2Color: DS.primaryTint,
        accent3Color: DS.textMuted,
        textColor: DS.ink,
        secondaryTextColor: DS.textSecondary,
        alternateTextColor: DS.surface,
        canvasColor: DS.surface,
        borderColor: DS.border,
        pickerHeaderColor: DS.primary
    },
    appBar: {
        height: 57,
        color: DS.surface,
        textColor: DS.ink
    },
    drawer: {
        width: 230,
        color: DS.primaryDeep
    },
    raisedButton: {
        primaryColor: DS.primary
    },
    flatButton: {
        primaryTextColor: DS.primary
    },
    paper: {
        color: DS.ink,
        backgroundColor: DS.surface
    },
    tableRow: {
        borderColor: DS.borderFaint,
        hoverColor: '#f8f9fb'
    },
    tableHeaderColumn: {
        textColor: DS.textMuted,
        height: 44
    },
    tableRowColumn: {
        height: 48
    },
    textField: {
        floatingLabelColor: DS.textMuted,
        hintColor: DS.textMuted,
        focusColor: DS.primary,
        borderColor: DS.borderStrong
    },
    menuItem: {
        hoverColor: DS.primaryTint,
        selectedTextColor: DS.primary
    },
    listItem: {
        nestedLevelDepth: 18
    },
    checkbox: {
        checkedColor: DS.primary
    },
    toggle: {
        thumbOnColor: DS.primary,
        trackOnColor: DS.primaryDisabled
    },
    datePicker: {
        color: DS.primary,
        selectColor: DS.primary,
        headerColor: DS.primary
    },
    circularProgress: {
        color: DS.primary
    }
});


export default themeDefault;
